import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { DffCookieConsentCookie } from "../dff-cookie-consent/dff-cookie-consent-cookie.model";
import { DffCookieConsentCookieWithDescription } from "../cookie-mapper.utils";

@Component({
    selector: "dff-cookie-consent-cookie-list",
    standalone: true,
    templateUrl: "./dff-cookie-consent-cookie-list.component.html",
    styleUrls: ["./dff-cookie-consent-cookie-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DffCookieConsentCookieListComponent {
    @Input()
    public cookies: DffCookieConsentCookieWithDescription[];

    constructor() {}
}
